<script>
import FormSelect from '@/src/components/form/Select.vue'
import CustomDatePickerRange from '@components/CustomDatePickerRange'
import { euroCouponsIssueMethods, euroCouponsTutorialMethods, euroHabeasDataReportsManagement, captacionMethods } from '@state/helpers'
export default {
  name: 'DownloadModal',
  components: { FormSelect, CustomDatePickerRange },
  props: {
    filters: {
      type: Object,
      required: true,
    },
    action: {
      type: Function,
      required: true,
    },
    loadingReport: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      modalShow: true,
      loading: true,
      toDetail: {},
    }
  },
  computed: {},

  mounted() {},
  methods: {
    ...euroHabeasDataReportsManagement,
    ...captacionMethods,
    setFilter(filter, value) {
      this.filters[filter] = value
      if (filter == 'CO') {
        this.cash_query = {
          key: 'co',
          value: this.filters.CO ? this.filters.CO : 'not',
        }
        this.filters.Caja = null
      }
    },
    getReport() {
      let _ = this
      _.loadingReport = true
      let query = `get_general_report?fecha__gte=${this.filters.fecha__gte}%2000%3A00%3A00.000&fecha__lte=${this.filters.fecha__lte}%2000%3A00%3A00.000`
      query += _.filterset ? `&${_.filterset}` : ''
      const promise = _.fetchReportManagementExcel({
        query: query,
        type: { responseType: 'arraybuffer' },
      })
      return promise
        .then((response) => {
          const data = response.data
          const url = URL.createObjectURL(
            new Blob([data], {
              type: 'application/vnd.ms-excel',
            })
          )
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', `Reporte de novedades.xlsx`)
          document.body.appendChild(link)
          link.click()
          _.loadingReport = false
        })
        .catch((error) => {
          _.loadingReport = false
          console.error(error)
          _.$axios_error_noty('Se presento un error en la descarga del archivo.',)
        })
    },
  },
}
</script>

<template>
  <b-modal
    v-model="modalShow"
    :title="`${$t('detail_of')} ${$t('issue')}`"
    ok-only
    hide-footer
    @hidden="oncancel"
  >
    <b-container class="p-0">
      <CustomDatePickerRange
        :label="'date'"
        :value_start="filters.fecha__gte"
        :value_end="filters.fecha__lte"
        @input_start="(value) => setFilter('fecha__gte', value)"
        @input_end="(value) => setFilter('fecha__lte', value)"
      />
      <b-button
        variant="outline-primary rounded-lg  mx-1"
        v-on:click="getReport"
      >
        <b-spinner v-if="loadingReport" small label="Spinning"></b-spinner>
        <i v-else class="fas fa-download"></i>
      </b-button>
    </b-container>
  </b-modal>
</template>
<style lang="scss"></style>
